export const snakeToCamelCase = (string) => {
  return string.replace(/([a-z0-9])_([a-z0-9])/gi, (match, p1, p2) => `${p1}${p2.toUpperCase()}`);
};

export const camelToSnakeCase = (string) => {
  return (string.match(/([a-zA-Z][^A-Z]*)/g) || [string]).map((str) => str.trim().toLowerCase()).join('_');
};

export const isBlank = (value) => {
  return value === null || value == undefined || value === '';
};

export function containsSpecialCharacter(string) {
  if (typeof string !== 'string') { return false; }
  return /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(string);
}
